'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReactAccelorometerValue = function (_Component) {
  _inherits(ReactAccelorometerValue, _Component);

  function ReactAccelorometerValue(props) {
    _classCallCheck(this, ReactAccelorometerValue);

    var _this = _possibleConstructorReturn(this, (ReactAccelorometerValue.__proto__ || Object.getPrototypeOf(ReactAccelorometerValue)).call(this, props));

    _this.handleOrientation = function () {
      var orientation = window.orientation;
      _this.setState({ landscape: orientation === 90 || orientation === -90 });
    };

    _this.handleAcceleration = function (event) {
      var landscape = _this.state.landscape;
      var acceleration = event.accelerationIncludingGravity;
      var rotation = event.rotationRate || 0;
      var x = acceleration.x;
      var y = acceleration.y;
      var z = acceleration.z;
      _this.setState({
        rotation: rotation,
        x: landscape ? y : x,
        y: landscape ? x : y,
        z: z,
        landscape: _this.state.landscape
      });
    };

    _this.state = {
      x: 0,
      y: 0,
      z: 0,
      rotation: {
        alpha: 0,
        beta: 0,
        gamma: 0
      },
      landscape: false
    };
    return _this;
  }

  _createClass(ReactAccelorometerValue, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.handleOrientation();
      if (typeof DeviceMotionEvent.requestPermission === 'function') {
        DeviceMotionEvent.requestPermission().then(function (permissionState) {
          if (permissionState === 'granted') {
            window.addEventListener('devicemotion', _this2.handleOrientation);
          }
        }).catch(console.error);
      } else {
        // handle regular non iOS 13+ devices
        window.addEventListener('devicemotion', this.handleAcceleration);
      }
      if (typeof DeviceOrientationEvent.requestPermission === 'function') {
        DeviceOrientationEvent.requestPermission().then(function (permissionState) {
          if (permissionState === 'granted') {
            window.addEventListener('deviceorientation', _this2.handleOrientation);
          }
        }).catch(console.error);
      } else {
        // handle regular non iOS 13+ devices
        window.addEventListener('orientationchange', this.handleOrientation);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('devicemotion', this.handleAcceleration);
      window.removeEventListener('orientationchange', this.handleOrientation);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return _react2.default.createElement(
        'div',
        null,
        _react.Children.map(this.props.children, function (child) {
          return (0, _react.cloneElement)(child, { state: _this3.state });
        })
      );
    }
  }]);

  return ReactAccelorometerValue;
}(_react.Component);

exports.default = ReactAccelorometerValue;